"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var processSelector_1 = __importDefault(require("./processSelector"));
var linkCellRenderer = function (textSelector, linkSelector) {
    return function (item) { return (react_1.default.createElement("a", { href: (0, processSelector_1.default)(item, linkSelector) }, (0, processSelector_1.default)(item, textSelector))); };
};
exports.default = linkCellRenderer;
